<template>
  <div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :disabled="disabled"
      :classification="classification"
      @reload="refresh"
      @openEditPage="openEditPage"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
      />
      <template #toolbar_btn>
        <SortFieldsPopover
          v-model="sortFields"
          :funcListName="funcListName"
          style="margin-right: 0.8em;"
          @change="$refs.header.query()"
        />
      </template>
    </page-main>
    <EditForm
      :visible.sync="editOptions.visible"
      :type="editOptions.type"
      @reload="refresh"
      :evgPlanOrderCode="evgPlanOrderCode"
      :evgPlanOrderWhCode="editOptions.code"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditForm from '../edit-form'
import SortFieldsPopover from '@/views/ecom/components/sort-fields-popover'

export default {
  mixins: [BaseTable],
  props: {
    evgPlanOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  components: { PageMain, PageHeader, EditForm, SortFieldsPopover },
  data() {
    return {
      editOptions: {
        visible: false,
        type: 'edit',
      },
      classification: '',
      funcListName: '',
      sortFields: [],
    }
  },
  methods: {
    openEditPage({ type, code }) {
      this.editOptions = {
        visible: true,
        type: type,
        code: code,
      }
    },
    async getData(form) {
      this.loading = true
      this.classification = form.classification

      switch (this.classification) {
        case 'C':
          this.funcListName = 'custPlanWhNameList'
          break
        case 'R':
          this.funcListName = 'custPlanDateList'
          break
        case 'M':
          this.funcListName = 'custPlanWhDetailList'
          break
        case 'S':
        this.funcListName = 'custPlanWhShippingList'
          break
        default:
          return
      }

      const res = await this.$api
        .ecomEvgPackingSchemeWhWarehouseListApi({
          ...form,
          evgPlanOrderCode: this.evgPlanOrderCode,
          sortFields: this.sortFields,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.tableData = res.body.data
    },
    refresh() {
      this.reload()
      this.$emit('refresh')
    },
  },
}
</script>
